<template>
	<div class="full">
		<div class="p11">
			<div class="p11_img20_img"><img src="../img/p11_img20_img.jpg" /></div>
			
			<div class="full animated bounceIn" style="-webkit-animation-delay: 1s;">
				<div class="full animated pulse infinite" style="-webkit-animation-delay: 1s;">
					<div class="p11_img19_img"><img src="../img/p11_img19_img.png" /></div>
					<div class="p11_img18_img"><img src="../img/p11_img18_img.png" /></div>
					<div class="p11_img17_img"><img src="../img/p11_img17_img.png" /></div>
					<div class="p11_img16_img"><img src="../img/p11_img16_img.png" /></div>
					<div class="p11_img15_img"><img src="../img/p11_img15_img.png" /></div>
					<div class="p11_img14_img"><img src="../img/p11_img14_img.png" /></div>
					<div class="p11_img13_img"><img src="../img/p11_img13_img.png" /></div>
					<div class="p11_img7_img"><img src="../img/p11_img7_img.png" /></div>
				</div>
			</div>
			
			<div class="p11_img12_img animated fadeInLeft"><img src="../img/p11_img12_img.png" /></div>
			<div class="p11_img11_img animated zoomIn"><img src="../img/p11_img11_img.png" /></div>
			<div class="p11_img10_img rabbit1"><img src="../img/p11_img10_img.png" /></div>
			<div class="p11_img9_img rabbit2"><img src="../img/p11_img9_img.png" /></div>
			<div class="p11_img8_img animated fadeInUp"><img class="animated tada infinite" style="-webkit-animation-delay: 2s;" src="../img/p11_img8_img.png" /></div>
			
			
			<div class="p11_img6_img" v-show="nextBuff"><img src="../img/p11_img6_img.png" /></div>
			<div class="p11_img5_img animated fadeInUp" style="-webkit-animation-delay: 2s;" v-show="!nextBuff" v-hammer:tap="next"><img src="../img/p11_img5_img.png" /></div>
			
			
			<div class="p11_img4_img animated zoomInDown"><img src="../img/p11_img4_img.png" /></div>
			<div class="p11_img3_img" v-hammer:tap="rule"><img src="../img/p11_img3_img.png" /></div>
			<div class="p11_img2_img" v-hammer:tap="mine"><img src="../img/p11_img2_img.png" /></div>
			<div class="p11_1" v-hammer:tap="bgm">
				<div class="p11_1_img2_img"><img src="../img/p11_1_img2_img.png" /></div>
				<div class="p11_1_img1_img" v-if="bgmIsPlay"><img src="../img/p11_1_img1_img.png" /></div>
			</div>
			<transition name="fade">
				<rule v-if="ruleShow" @ruleBack="ruleBack"  />
			</transition>
			<transition name="fade">
				<mine v-if="mineShow" @back="mineShow=false"  />
			</transition>			
			
		</div>
	</div>
</template>

<style scoped>
.p11_img20_img{position:absolute;left:0.00%;top:0.00%;width:100.00%;height:100.00%;}
.p11_img19_img{position:absolute;left:18.53%;top:34.34%;width:37.07%;height:12.34%;}
.p11_img18_img{position:absolute;left:15.73%;top:44.57%;width:19.34%;height:9.20%;}
.p11_img17_img{position:absolute;left:66.53%;top:49.10%;width:13.60%;height:6.59%;}
.p11_img16_img{position:absolute;left:80.27%;top:45.97%;width:10.00%;height:5.37%;}
.p11_img15_img{position:absolute;left:7.60%;top:55.31%;width:7.20%;height:3.13%;}
.p11_img14_img{position:absolute;left:85.33%;top:55.56%;width:6.27%;height:2.75%;}
.p11_img13_img{position:absolute;left:87.60%;top:58.31%;width:4.00%;height:1.86%;}
.p11_img12_img{position:absolute;left:59.07%;top:37.92%;width:24.80%;height:14.25%;}
.p11_img11_img{position:absolute;left:14.50%;top:29.4%;width:58.8%;}
.p11_img10_img{position:absolute;left:6.80%;top:54.67%;width:35.33%;height:16.69%;}
.p11_img9_img{position:absolute;left:47.20%;top:50.13%;width:42.40%;height:22.50%;}
.p11_img8_img{position:absolute;left:34.67%;top:60.87%;width:25.20%;height:12.08%;}
.p11_img7_img{position:absolute;left:11.60%;top:51.15%;width:76.40%;height:21.55%;}
.p11_img6_img{position:absolute;left:14.80%;top:76.21%;width:70.00%;height:8.38%;}
.p11_img5_img{position:absolute;left:22.80%;top:75.64%;width:54.93%;height:9.46%;}
.p11_img4_img{position:absolute;left:14.27%;top:14.07%;width:72.13%;height:13.62%;}
.p11_img3_img{position:absolute;left:0.00%;top:25.38%;width:18.27%;height:7.48%;}
.p11_img2_img{position:absolute;left:88.53%;top:24.04%;width:9.20%;height:5.95%;}
.p11_1_img2_img{position:absolute;left:0.00%;top:3.19%;width:100.00%;height:96.81%;}
.p11_1_img1_img{position:absolute;left:0.00%;top:0.00%;width:100.00%;height:100.00%;}
.p11_1{position:absolute;left:88.53%;top:17.07%;width:9.20%;height:5.95%;}
.p11{position:absolute;left:0.00%;top:0.00%;width:100%;height:100%;}
.rule_bg{
	position: absolute;
	width: 79.2%;
	height: 60.2%;
	left: 10.4%;
	top: 21.3%;
}
.rule_content{
	position: absolute;
	width: 65.2%;
	height: 58.8%;
	left: 18.4%;
	top: 18.7%;	
}
.rule_back{
	position: absolute;
	width: 10.8%;
	height: 6.8%;
	left: 44.6%;
	top: 93.2%;		
}
	.rabbit1 {
		-webkit-animation: rabbit1 .5s linear forwards;
	}
	@-webkit-keyframes rabbit1 {
		0% {
			-webkit-transform: translate(60px,60px);opacity: 0;
		}
		100% {
			-webkit-transform: translate(0,0);opacity: 1;
		}
	}
	.rabbit2 {
		-webkit-animation: rabbit2 .5s linear forwards;
	}
	@-webkit-keyframes rabbit2 {
		0% {
			-webkit-transform: translate(-60px,60px);opacity: 0;
		}
		100% {
			-webkit-transform: translate(0,0);opacity: 1;
		}
	}	
</style>
<script>
	export default {
		data() {
			return {
				nextBuff:false,
				ruleShow:false,
				mineShow:false
			};
		},
		computed: {
			bgmIsPlay() {
				return this.$store.state.bgmIsPlay
			}
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			bgm(){
				this.$emit('bgm')
			},
			next(){
				
				if(!this.nextBuff){
					this.nextBuff = true
					setTimeout(()=>{
						this.$store.commit('setCurrentPage', {
							page: 'game1'
						})
					},300)
					this.$store.commit('playYinxiao',{name:'tap'})
				}

			},
			rule(){
				this.ruleShow = true
			},
			ruleBack(){
				this.ruleShow = false
			},
			mine(){
				this.mineShow = true
				// this.$store.commit('setCurrentPage', {
				// 	page: 'mine'
				// })
			}
		},
		components: {

		}
	}
</script>
